import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { JobsOffer } from '../../models/jobs-offer';
import { CandidateService } from '../../services/candidate.service';
import { ApplicantFilter } from '../../interfaces/filters';

@Injectable()
export class OfferStore {
  private _offers: BehaviorSubject<JobsOffer[]> = new BehaviorSubject([]);
  private _page: BehaviorSubject<number> = new BehaviorSubject(1);
  private _total: BehaviorSubject<number> = new BehaviorSubject(0);
  private _loading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _lastPage: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private page: number;
  private total: number;
  private filter:ApplicantFilter;
  private pagecount: number;

  constructor(private candidateBackendService: CandidateService) {
    //this.loadInitialData(1);
  }

  get offers() {
    return this._offers.asObservable();
  }

  get currentPage() {
    return this._page.asObservable();
  }

  get getTotal() {
    return this._total.asObservable();
  }

  get loading() {
    return this._loading.asObservable();
  }

  get lastPage() {
    return this._lastPage.asObservable();
  }

  changeFilters(filters: ApplicantFilter, requirement: boolean, page: number, pagecount?: number, jobId?: string) {
    this.filter = filters;
    this.pagecount = pagecount;
    this._loading.next(true);
    this.candidateBackendService.getCandidates(filters, requirement, page, pagecount, jobId)
      .subscribe(
        res => {
          this.page = page;
          this.total = res.pagination.total;
          this._page.next(page);
          this._total.next(this.total);
          this._offers.next(res.applicants);
          this._loading.next(false);
          this._lastPage.next(this.page >= this.maxPages());
        },
        () => {
          console.log("Error retrieving Jobs");
          this._loading.next(false);
        }
      );
  }

  private maxPages() {
    return Math.ceil(this.total / (this.pagecount || 10));
  }

  nextPage(requirement, jobInvited) {
    if(this.page < this.maxPages()) {
      if (jobInvited) {
        this.changeFilters(this.filter, requirement, this.page + 1, this.pagecount, jobInvited);
      } else {
        this.changeFilters(this.filter, requirement, this.page + 1, this.pagecount);
      }
    }
  }

  prevPage(requirement, jobInvited) {
    if(this.page > 1) {
      if (jobInvited) {
        this.changeFilters(this.filter, requirement, this.page - 1, this.pagecount, jobInvited);
      } else {
        this.changeFilters(this.filter, requirement, this.page - 1, this.pagecount);
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/state/offer.store.ts